<template>
    <div
        id="expenses-app"
        class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden"
        v-if="isCreated"
    >
        <requests-sidemenu
            v-model="sidebarActive"
            ref="sidebar"
            parent="#expenses-app"
            :click-not-close="clickNotClose"
            :hidden-background="clickNotClose"
            :is-created="isCreated"
        />

        <div
            :class="{ 'sidebar-spacer': sidebarActive }"
            class="no-scroll-content border border-solid d-theme-border-grey-light border-r-0 border-t-0 border-b-0"
        >
            <transition :name="transitionName">
                <router-view @toggle-side-bar="toggleSideBar"></router-view>
            </transition>
        </div>
    </div>
</template>

<script>
import RequestsSidemenu from './RequestsSidemenu.vue'
import { mapGetters } from 'vuex'

export default {
    name: 'dashboard',
    components: {
        RequestsSidemenu
    },
    data() {
        return {
            clickNotClose: true,
            sidebarActive: true,
            isCreated: false,
            transitionName: 'slide-fade-left',
            isSmallScreen: null
        }
    },
    watch: {
        $route(to, from) {
            if (from.path.indexOf(to.path) > -1) {
                // back nav
                this.transitionName = 'slide-swap-back'
            } else {
                this.transitionName = 'slide-swap'
            }
        },
        windowWidth() {
            this.setSidebarWidth()
        }
    },
    computed: {},
    methods: {
        setSidebarWidth() {
            // Note: this.windowWidth is not being set
            this.windowWidth = window.innerWidth
            if (this.windowWidth < 992) {
                this.sidebarActive = this.clickNotClose = false
            } else {
                this.sidebarActive = this.clickNotClose = true
            }
        },
        toggleSideBar() {
            if (this.sidebarActive) {
                this.sidebarActive = false
            } else {
                this.sidebarActive = true
            }
        }
    },
    async mounted() {
        this.setSidebarWidth()
        this.isCreated = true
    }
}
</script>

<style scoped></style>

<style lang="scss">
@import '@/assets/scss/vuexy/apps/crm.scss';
</style>
